import Link from 'next/link'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faUserCircle} from '@fortawesome/free-solid-svg-icons'
import {DateTime} from 'luxon'
import TutorProfileRating from './Rating'
import styles from './ReviewsList.module.scss'

export default function TutorProfileReviewsList({tutorProfile, reviews, showSeeAll=true}) {
  return <>
    {reviews.map(review => (
      <div className={styles.review} key={review.id}>
        <div className="d-flex justify-content-start">
          <FontAwesomeIcon icon={faUserCircle} size="2x" className="text-secondary me-2"/>
          <div className="mb-2">
            <h6 className="mb-0">{review.clientProfile.firstNameAndLastInitial}</h6>
            <em className="small">{DateTime.fromISO(review.createdAt).toLocaleString(DateTime.DATE_FULL)}</em>
          </div>
        </div>
        <div className="d-flex">
          <div className="d-flex me-2">
            <TutorProfileRating tutorProfile={tutorProfile} showCount={false} />
          </div>
          <div className={styles.reviewContent}>
            {review.message}
          </div>
        </div>
      </div>
    ))}

    {showSeeAll &&
      <div className="mt-3 text-center">
        <Link href={`/tutors/${tutorProfile.slug}/reviews`} passHref>
          See All{tutorProfile.tutorReviewsCount}Reviews
        </Link>
      </div>
    }
  </>
}
